function createScript() {
  const script = document.createElement('script');
  script.setAttribute('type', 'application/ld+json');
  return script;
}

function getSchemaData(content) {
  if(!content) return null;
  if(Array.isArray(content) && content.length > 1) {
    return {
      '@context': 'https://schema.org',
      '@graph': content,
    };
  } else if(typeof content === 'object') {
    return {
      '@context': 'https://schema.org',
      ...content,
    };
  }
  return null;
}

export const jsonLdMixin = {
  created() {
    this.$jsonLdScript = null;
    this.$jsonLdWatcher = null;
  },
  mounted() {
    if(typeof this.$options.schema === 'function') {
      try {
        this.$jsonLdScript = createScript();
        document.head.appendChild(this.$jsonLdScript);
        this.$jsonLdWatcher = this.$watch(
          () => this.$options.schema.call(this),
          (newData) => {
            this.updateJsonLd(newData);
          },
          {
            immediate: true,
            deep: true,
          }
        )
      } catch(e) {
        console.log(e);
      }
    }
  },
  methods: {
    updateJsonLd(content) {
      if(!this.$jsonLdScript || !content) return;
      try {
        const schemaData = getSchemaData(content);
        this.$jsonLdScript.textContent = JSON.stringify(schemaData, null, 2);
      } catch(e) {
        console.log(e);
      }
    }
  },
  unmounted() {
    if(this.$jsonLdWatcher) {
      this.$jsonLdWatcher();
    }

    if(
      this.$jsonLdScript !== null &&
      document.head.contains(this.$jsonLdScript)
    ) {
      document.head.removeChild(this.$jsonLdScript);
    }
  },
}
